import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const ProductPreparing = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	const tab = new URLSearchParams(window.location.search).get('tab')

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, productPreparing: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}
	
	const steps = [
		{
			target: '.productPreparingFirstStep',
			title: "View Order",
			content: 'Click to view order details.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productPreparingSecondStep',
			title: "Update Order",
			content: 'Click to update the status of this order.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productPreparingThirdStep',
			title: "Print Order",
			content: 'Click to proceed view printing.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productPreparingFourthStep',
			title: "Print Sales Order",
			content: 'Click to print the actual printing.',
			disableBeacon: true,
			placement: "left",
			modalTriggers: 'productPreparing'
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.productPreparingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, [tab, walkthrough.data.productPreparing]);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.productPreparing)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="productPreparing" 
			featureName="sales"
		/>
	);
}
